import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSubscription } from '../../context/SubscriptionContext';
import { useProduct } from '../../context/ProductContext';

import { sendGTMEvent } from '../../utils/analytics';
import { GA4_KEY, ROUTES } from '../../utils/constants';

import SubscriptionInformation from '../../components/SubscriptionInformation/SubscriptionInformation';
import SubscriptionMenu from '../../components/SubscriptionMenu/SubscriptionMenu';

import styles from './Subscription.module.css';
import { colors } from '../../styles/colors';

const Subscription = () => {
  const navigate = useNavigate();
  const widget = new window.cp.CloudPayments();
  const { state } = useLocation();
  const { subscriptionInfo, isHaveSubscriptionHash } = useSubscription();
  const { setProductId } = useProduct();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const [isShowPaymentsHistory, setIsShowPaymentsHistory] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isResetModalOpen, setIsResetModalOpen] = useState(false);

  const {
    user_data: { premium },
  } = subscriptionInfo;

  const handleBackButton = () => {
    window.Telegram.WebApp.HapticFeedback.impactOccurred('medium');

    if (isPaymentOpen) {
      widget.close();
      setIsPaymentOpen(false);
      return;
    }

    if (isShowPaymentsHistory) {
      setIsShowPaymentsHistory(false);
      return;
    }

    if (isDrawerOpen) {
      setIsDrawerOpen(false);
      return;
    }

    if (isResetModalOpen) {
      setIsResetModalOpen(false);
      return;
    }

    if (isHaveSubscriptionHash) {
      navigate(ROUTES.home);
      return;
    }

    if (state?.from.includes('products')) {
      const id = state?.from.split('/').pop();
      setProductId(id);
    }
    navigate(state?.from || ROUTES.home);
  };

  useEffect(() => {
    sendGTMEvent(GA4_KEY.navigate(window.location.href));

    window.Telegram.WebApp.BackButton.show();
    window.Telegram.WebApp.setHeaderColor(
      isPaymentOpen
        ? '#222D42'
        : isShowPaymentsHistory
        ? colors.background.main
        : isDrawerOpen || isCancelModalOpen || isResetModalOpen
        ? '#7F7F7F'
        : colors.background.main
    );
    window.Telegram.WebApp.BackButton.onClick(handleBackButton);

    return () => {
      window.Telegram.WebApp.BackButton.hide();
      window.Telegram.WebApp.BackButton.offClick(handleBackButton);
    };
    // eslint-disable-next-line
  }, [
    isDrawerOpen,
    isPaymentOpen,
    isShowPaymentsHistory,
    isCancelModalOpen,
    isResetModalOpen,
  ]);

  return (
    <div className={styles.container}>
      {premium ? (
        <SubscriptionInformation
          setIsDrawerOpen={setIsDrawerOpen}
          isDrawerOpen={isDrawerOpen}
          setIsShowPaymentsHistory={setIsShowPaymentsHistory}
          isShowPaymentsHistory={isShowPaymentsHistory}
          isCancelModalOpen={isCancelModalOpen}
          setIsCancelModalOpen={setIsCancelModalOpen}
          isResetModalOpen={isResetModalOpen}
          setIsResetModalOpen={setIsResetModalOpen}
        />
      ) : (
        <SubscriptionMenu widget={widget} setIsPaymentOpen={setIsPaymentOpen} />
      )}
    </div>
  );
};

export default Subscription;
